import { lazy } from "react";

// 懒加载页面组件
export const Dashboard = lazy(() => 
  import("../pages/Dashboard").then(module => ({
    default: module.default
  }))
);

export const OfferDetail = lazy(() => 
  import("../pages/OfferDetail").then(module => ({
    default: module.default
  }))
);

export const OfferEdit = lazy(() => 
  import("../pages/OfferEdit").then(module => ({
    default: module.default
  }))
);

export const MySettings = lazy(() => 
  import("../pages/MySettings").then(module => ({
    default: module.default
  }))
);

export const Blacklist = lazy(() => 
  import("../pages/Blacklist").then(module => ({
    default: module.default
  }))
);

export const GoogleAds = lazy(() => 
  import("../pages/GoogleAds").then(module => ({
    default: module.default
  }))
);

export const Profile = lazy(() => 
  import("../pages/Profile").then(module => ({
    default: module.default
  }))
);

export const IdleAccounts = lazy(() => 
  import("../pages/IdleAccounts").then(module => ({
    default: module.default
  }))
);

export const EmailManagement = lazy(() => 
  import("../pages/EmailManagement").then(module => ({
    default: module.default
  }))
);

export const PermissionManagement = lazy(() => 
  import("../pages/PermissionManagement").then(module => ({
    default: module.default
  }))
);

export const AdsRecords = lazy(() => 
  import("../pages/AdsRecords").then(module => ({
    default: module.default
  }))
);

export const RecommendedOffers = lazy(() =>
  import("../pages/RecommendedOffers").then((module) => ({
    default: module.default,
  })),
);

export const PostBack = lazy(() =>
  import("../pages/PostBack").then((module) => ({
    default: module.default,
  })),
);

// 预加载关键页面
export const preloadCriticalPages = () => {
  // 预加载Dashboard（最常用）
  import("../pages/Dashboard");
  
  // 延迟预加载其他常用页面
  setTimeout(() => {
    import("../pages/OfferDetail");
    import("../pages/MySettings");
  }, 2000);
  
  setTimeout(() => {
    import("../pages/GoogleAds");
    import("../pages/EmailManagement");
  }, 5000);
};